<template>
  <!-- <div class="form-config-container"> -->
  <a-form class="cc" labelWrap="true">
    <a-form-item :label="$t('fm.config.form.labelPosition.title')">
      <a-radio-group v-model="data.labelPosition">
        <a-radio-button label="left">{{ $t('fm.config.form.labelPosition.left') }}</a-radio-button>
        <a-radio-button label="right">{{ $t('fm.config.form.labelPosition.right') }}</a-radio-button>
        <a-radio-button label="top">{{ $t('fm.config.form.labelPosition.top') }}</a-radio-button>
      </a-radio-group>
    </a-form-item>

    <a-form-item :label="$t('fm.config.form.labelWidth')">
      <a-input-number :max="200" :min="0" :step="10" v-model="data.labelWidth" />
    </a-form-item>

    <a-form-item :label="$t('fm.config.form.size')">
      <a-radio-group v-model="data.size">
        <a-radio-button label="medium">medium</a-radio-button>
        <a-radio-button label="small">small</a-radio-button>
        <a-radio-button label="mini">mini</a-radio-button>
      </a-radio-group>
    </a-form-item>
  </a-form>
  <!-- </div> -->
</template>

<script>
  export default {
    /* eslint-disable */
    props: ['data']
  }
</script>
